import {
  LogLinesSkeleton,
  LogVolumeChartFallback,
} from '@/components/shared/logs-explorer'
import { Separator } from '@/components/ui/separator'
import { Skeleton } from '@/components/ui/skeleton'
import * as Styled from '@/routes/app/tabs/runtime-logs/runtime-logs-data/styles'

export const AppRuntimeLogsDataFallback = () => {
  return (
    <Styled.Container>
      <Styled.LogsWithSidebar>
        <div className="flex flex-col border-r bg-muted/30 w-[260px] shrink-0 overflow-y-auto">
          <div className="flex items-center justify-between px-3 py-5 border-b">
            <div className="flex items-center gap-2">
              <Skeleton className="size-4 rounded" />
              <Skeleton className="h-4 w-12" />
            </div>
            <Skeleton className="size-7" />
          </div>

          <div className="flex flex-col gap-4 px-3 py-3">
            <Skeleton className="h-9 w-full" />
          </div>

          <Separator />

          <div className="flex-1 flex flex-col gap-3 px-3 py-3">
            <Skeleton className="h-8 w-full" />
          </div>

          <div className="border-t px-3 py-3">
            <Skeleton className="h-8 w-full" />
          </div>
        </div>

        <Styled.LogsContent>
          <div className="bg-background py-4 px-4 w-full flex items-center gap-4 border-b">
            <Skeleton className="h-9 flex-1 lg:min-w-[400px]" />
            <div className="flex">
              <Skeleton className="h-9 w-32 rounded-r-none" />
              <Skeleton className="h-9 w-10.5 rounded-l-none border-l-0" />
            </div>
            <Skeleton className="size-9 shrink-0" />
          </div>
          <LogVolumeChartFallback />
          <LogLinesSkeleton />
        </Styled.LogsContent>
      </Styled.LogsWithSidebar>
    </Styled.Container>
  )
}
